import type { DockviewApi } from 'dockview';
import { applyLayoutConstraints } from '../../../components/Layout/utils/utils';
import type { LayoutSpec } from '../../../types/LayoutConfig';

export function applyLayoutSpec(dockviewApi: DockviewApi, newLayoutSpec: LayoutSpec) {
  dockviewApi.fromJSON(newLayoutSpec.dockViewLayout);
  applyLayoutConstraints(newLayoutSpec.constraints, dockviewApi);
}
